import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Gift, Share2, Camera, Upload, CheckCircle2, Music2, Instagram, Facebook, ImagePlus, PartyPopper, Sparkles, Smartphone, Euro, Rocket, FileText, Lock, ChevronDown } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Seo } from "../components/Seo";

const TICKER = ["3× iPHONE 18 PRO MAX BURGUNDER", "3× 500 € BARGELD", "30× BOOST-PAKETE", "01.12.2026 – 31.01.2027", "100 % KOSTENLOS"];
const PRIZES = [
  { icon: Smartphone, big: "3×", title: "iPhone 18 Pro Max", sub: "in Burgunder, originalverpackt – direkt zu dir nach Hause", rotate: "-rotate-1" },
  { icon: Euro, big: "3×", title: "500 € Bargeld", sub: "Auszahlung bequem per Banküberweisung aufs Konto", rotate: "rotate-1" },
  { icon: Rocket, big: "30×", title: "Boost-Paket", sub: "je 30 Boosts, damit deine Inserate ganz oben landen", rotate: "-rotate-1" },
];
const STEPS = [
  { icon: Share2, title: "Inserat teilen", text: "Poste eines deiner KLEDIO-Inserate öffentlich auf TikTok, Instagram oder Facebook." },
  { icon: Camera, title: "Screenshot machen", text: "Mache einen Screenshot deines veröffentlichten Beitrags." },
  { icon: Upload, title: "Hochladen – fertig!", text: "Lade den Screenshot hier hoch. Das war's, du bist im Lostopf." },
];
const PLATFORM_OPTS = [
  { key: "tiktok", label: "TikTok", icon: Music2 },
  { key: "instagram", label: "Instagram", icon: Instagram },
  { key: "facebook", label: "Facebook", icon: Facebook },
];

const TERMS = [
  ["Veranstalter", "Veranstalter des Gewinnspiels ist KLEDIO (nachfolgend „Veranstalter“). Das Gewinnspiel steht in keiner Verbindung zu TikTok, Instagram oder Facebook (Meta Platforms) und wird in keiner Weise von diesen Plattformen gesponsert, unterstützt oder organisiert. Ansprüche im Zusammenhang mit dem Gewinnspiel richten sich ausschließlich an den Veranstalter."],
  ["Teilnahmezeitraum", "Das Gewinnspiel läuft vom 01.12.2026, 00:00 Uhr, bis einschließlich 31.01.2027, 23:59 Uhr (jeweils deutsche Zeit). Teilnahmen, die nach Ablauf des Zeitraums eingehen, werden nicht berücksichtigt."],
  ["Teilnahmeberechtigung", "Teilnahmeberechtigt sind alle registrierten KLEDIO-Nutzerinnen und -Nutzer, die zum Zeitpunkt der Teilnahme mindestens 18 Jahre alt sind und ihren Wohnsitz in Deutschland haben. Mitarbeitende des Veranstalters sowie deren Angehörige sind von der Teilnahme ausgeschlossen. Pro Person ist nur eine Teilnahme möglich; Mehrfachteilnahmen (auch über mehrere Konten) führen zum Ausschluss."],
  ["Teilnahme", "Die Teilnahme erfolgt in drei Schritten: (1) Teile eines deiner eigenen KLEDIO-Inserate öffentlich auf TikTok, Instagram oder Facebook. (2) Mache einen Screenshot des veröffentlichten Beitrags. (3) Lade den Screenshot über das Teilnahmeformular auf der Gewinnspiel-Seite hoch und akzeptiere diese Teilnahmebedingungen. Die Teilnahme ist kostenlos; es ist kein Kauf erforderlich. Der geteilte Beitrag muss bis zum Ende des Teilnahmezeitraums öffentlich abrufbar bleiben."],
  ["Gewinne", "Unter allen gültigen Teilnahmen werden folgende Gewinne verlost: 3× ein Apple iPhone 18 Pro Max in Burgunder (originalverpackt, Versand an die Lieferadresse), 3× 500 € (Auszahlung per Banküberweisung) sowie 30× ein Paket mit 30 Boosts für Inserate auf KLEDIO. Eine Barauszahlung der Boost-Pakete, ein Umtausch oder eine Übertragung der Gewinne auf Dritte ist ausgeschlossen. Pro Person ist maximal ein Gewinn möglich."],
  ["Ermittlung und Benachrichtigung der Gewinner", "Die Gewinnerinnen und Gewinner werden innerhalb von 14 Tagen nach Ende des Teilnahmezeitraums per Losverfahren unter allen gültigen Teilnahmen ermittelt und über ihr KLEDIO-Konto (Benachrichtigung und/oder E-Mail) informiert. Für die Auszahlung der Geldgewinne ist die Angabe einer gültigen Bankverbindung (IBAN) erforderlich. Meldet sich ein Gewinner nicht innerhalb von 14 Tagen nach Benachrichtigung oder können die für die Auszahlung erforderlichen Angaben nicht beigebracht werden, verfällt der Gewinn und kann neu verlost werden."],
  ["Ausschluss und vorzeitige Beendigung", "Der Veranstalter behält sich vor, Teilnehmende bei Verstößen gegen diese Bedingungen, bei Manipulation (z.B. gefälschte Screenshots, fremde Inserate, automatisierte Teilnahmen) oder bei Verstößen gegen die KLEDIO-Nutzungsbedingungen auszuschließen. Der Veranstalter kann das Gewinnspiel aus wichtigem Grund (z.B. technische Störungen, rechtliche Gründe) ganz oder teilweise vorzeitig beenden oder anpassen; bereits erworbene Gewinnansprüche ausgeloster Gewinner bleiben davon unberührt."],
  ["Rechte an den Inhalten", "Mit dem Upload bestätigst du, dass du den geteilten Beitrag selbst erstellt hast und über die erforderlichen Rechte am Screenshot verfügst. Der Screenshot wird ausschließlich zur Prüfung der Teilnahme verwendet und nicht veröffentlicht."],
  ["Schlussbestimmungen", "Der Rechtsweg ist hinsichtlich der Ziehung der Gewinner ausgeschlossen. Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen dieser Teilnahmebedingungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt."],
];

const PRIVACY = [
  ["Verantwortlicher", "Verantwortlich für die Datenverarbeitung im Rahmen dieses Gewinnspiels ist KLEDIO. Die Kontaktdaten findest du im Impressum."],
  ["Verarbeitete Daten", "Zur Durchführung des Gewinnspiels verarbeiten wir: deine KLEDIO-Kontodaten (Nutzer-ID, Anzeigename, E-Mail-Adresse), die gewählte Plattform, den optional angegebenen Beitragslink, den hochgeladenen Screenshot sowie den Zeitpunkt der Teilnahme. Im Gewinnfall zusätzlich die für die Auszahlung erforderliche Bankverbindung (IBAN, Kontoinhaber)."],
  ["Zwecke und Rechtsgrundlage", "Die Verarbeitung erfolgt ausschließlich zur Durchführung des Gewinnspiels: Prüfung der Teilnahme, Ermittlung und Benachrichtigung der Gewinner sowie Auszahlung bzw. Gutschrift der Gewinne. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Durchführung des Gewinnspielvertrags). Soweit wir Auszahlungsnachweise aufbewahren müssen, erfolgt dies auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO (gesetzliche Aufbewahrungspflichten)."],
  ["Keine Weitergabe, keine Werbung", "Deine Teilnahmedaten werden nicht an Dritte weitergegeben und nicht zu Werbezwecken verwendet. Es findet keine Datenübermittlung an TikTok, Instagram oder Facebook statt. Der hochgeladene Screenshot wird nicht veröffentlicht."],
  ["Speicherdauer", "Teilnahmedaten und Screenshots werden spätestens drei Monate nach Abschluss des Gewinnspiels (Ende der Gewinnabwicklung) gelöscht. Daten von Gewinnern, die gesetzlichen Aufbewahrungspflichten unterliegen (z.B. Auszahlungsbelege), werden erst nach Ablauf dieser Fristen gelöscht."],
  ["Deine Rechte", "Dir stehen die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch zu. Außerdem hast du das Recht, dich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Zur Ausübung deiner Rechte kontaktiere uns über die Kontaktseite. Ergänzend gilt unsere allgemeine Datenschutzerklärung."],
];

function Ticker() {
  const row = TICKER.map((t, i) => (
    <span key={i} className="flex items-center gap-6 shrink-0">
      <span className="text-[12px] font-black tracking-[0.15em] uppercase whitespace-nowrap">{t}</span>
      <Sparkles className="w-3.5 h-3.5 text-white/70 shrink-0" />
    </span>
  ));
  return (
    <div className="bg-accent text-white overflow-hidden rounded-full" data-testid="giveaway-ticker">
      <style>{`@keyframes gw-marquee{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}`}</style>
      <div className="flex gap-6 py-2.5 w-max" style={{ animation: "gw-marquee 24s linear infinite" }}>
        <div className="flex gap-6">{row}</div>
        <div className="flex gap-6" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
}

function LegalItem({ num, title, text, open, onToggle, testid }) {
  return (
    <div className={`border rounded-2xl transition-colors ${open ? "border-accent/40 bg-white" : "border-border bg-white/60 hover:border-accent/30"}`}>
      <button type="button" data-testid={testid} onClick={onToggle} aria-expanded={open}
        className="w-full flex items-center gap-3.5 px-4 py-3.5 text-left">
        <span className={`w-8 h-8 rounded-xl flex items-center justify-center text-xs font-black shrink-0 ${open ? "bg-accent text-white" : "bg-secondary text-foreground/60"}`}>{num}</span>
        <span className="flex-1 text-sm font-bold">{title}</span>
        <ChevronDown className={`w-4 h-4 text-muted-foreground shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <p className="px-4 pb-4 pl-[66px] text-sm text-foreground/75 leading-relaxed">{text}</p>}
    </div>
  );
}

function LegalHub() {
  const [tab, setTab] = useState("terms");
  const [open, setOpen] = useState(0);
  useEffect(() => { setOpen(0); }, [tab]);
  const items = tab === "terms" ? TERMS : PRIVACY;
  return (
    <section className="mt-14 scroll-mt-24" id="rechtliches" data-testid="giveaway-legal-hub">
      <div className="flex items-center gap-3">
        <span className="w-11 h-11 rounded-2xl bg-[#111111] text-accent flex items-center justify-center rotate-3"><FileText className="w-5 h-5" /></span>
        <div>
          <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight">Das Kleingedruckte</h2>
          <p className="text-sm text-muted-foreground">Fair, transparent und zum Aufklappen – kein Juristendeutsch-Marathon.</p>
        </div>
      </div>
      <div className="flex w-full max-w-md bg-secondary/80 rounded-full p-1 mt-6">
        <button type="button" data-testid="legal-tab-terms" onClick={() => setTab("terms")}
          className={`flex-1 text-xs sm:text-sm font-bold px-3 sm:px-5 py-2.5 rounded-full transition-colors whitespace-nowrap ${tab === "terms" ? "bg-[#111111] text-white" : "text-foreground/60 hover:text-foreground"}`}>
          Teilnahmebedingungen
        </button>
        <button type="button" data-testid="legal-tab-privacy" onClick={() => setTab("privacy")}
          className={`flex-1 text-xs sm:text-sm font-bold px-3 sm:px-5 py-2.5 rounded-full transition-colors whitespace-nowrap ${tab === "privacy" ? "bg-[#111111] text-white" : "text-foreground/60 hover:text-foreground"}`}>
          Datenschutzhinweis
        </button>
      </div>
      <div id="teilnahmebedingungen" data-testid="giveaway-terms" className={`mt-5 space-y-2.5 max-w-3xl scroll-mt-24 ${tab === "terms" ? "" : "hidden"}`}>
        {TERMS.map(([h, p], i) => (
          <LegalItem key={h} num={i + 1} title={h} text={p} open={tab === "terms" && open === i} onToggle={() => setOpen(open === i ? -1 : i)} testid={`terms-item-${i + 1}`} />
        ))}
      </div>
      <div id="datenschutzhinweis" data-testid="giveaway-privacy" className={`mt-5 space-y-2.5 max-w-3xl scroll-mt-24 ${tab === "privacy" ? "" : "hidden"}`}>
        {PRIVACY.map(([h, p], i) => (
          <LegalItem key={h} num={i + 1} title={h} text={p} open={tab === "privacy" && open === i} onToggle={() => setOpen(open === i ? -1 : i)} testid={`privacy-item-${i + 1}`} />
        ))}
        <p className="flex items-center gap-2 text-xs text-muted-foreground pt-1"><Lock className="w-3.5 h-3.5 text-accent" /> Dein Screenshot wird nicht veröffentlicht und spätestens 3 Monate nach Ende der Gewinnabwicklung gelöscht.</p>
      </div>
    </section>
  );
}

function EntryForm({ onEntered, scrollToLegal }) {
  const [platform, setPlatform] = useState(null);
  const [postUrl, setPostUrl] = useState("");
  const [image, setImage] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [terms, setTerms] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/uploads/image", fd);
      setImage({ id: data.image_id, name: file.name });
      toast.success("Screenshot hochgeladen");
    } catch (err) { toast.error(errText(err)); } finally { setUploading(false); }
  };

  const submit = async () => {
    if (!platform) return toast.error("Bitte wähle die Plattform, auf der du gepostet hast.");
    if (!image) return toast.error("Bitte lade einen Screenshot deines Beitrags hoch.");
    if (!terms) return toast.error("Bitte akzeptiere die Teilnahmebedingungen.");
    if (!privacy) return toast.error("Bitte bestätige den Datenschutzhinweis.");
    setBusy(true);
    try {
      await api.post("/giveaway/enter", { platform, post_url: postUrl || null, image_id: image.id, accept_terms: true, accept_privacy: true });
      toast.success("Du bist im Lostopf! Viel Glück 🍀");
      onEntered();
    } catch (err) { toast.error(errText(err)); } finally { setBusy(false); }
  };

  const check = "mt-0.5 w-[18px] h-[18px] rounded border-border accent-[#FF6B35] shrink-0 cursor-pointer";

  return (
    <div className="relative" id="teilnehmen">
      <div aria-hidden="true" className="absolute -inset-1 rounded-[28px] bg-gradient-to-br from-accent via-[#FFB38A] to-accent opacity-80 blur-[2px]" />
      <div className="relative bg-white rounded-3xl p-5 md:p-8" data-testid="giveaway-form">
        <span className="inline-block -rotate-2 bg-[#111111] text-white text-[11px] font-black tracking-[0.2em] uppercase px-3.5 py-1.5 rounded-lg">Mitmachen in 60 Sekunden</span>
        <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight mt-3">Ab in den Lostopf.</h2>

        <p className="text-sm font-bold mt-6 mb-2.5 flex items-center gap-2"><span className="w-6 h-6 rounded-lg bg-accent text-white text-[11px] font-black flex items-center justify-center">1</span> Wo hast du gepostet?</p>
        <div className="flex flex-wrap gap-2.5">
          {PLATFORM_OPTS.map((p) => (
            <button key={p.key} type="button" data-testid={`giveaway-platform-${p.key}`} onClick={() => setPlatform(p.key)}
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-bold border-2 transition-all ${platform === p.key ? "bg-accent text-white border-accent scale-[1.03]" : "bg-white border-border hover:border-accent/60"}`}>
              <p.icon className="w-4 h-4" /> {p.label}
            </button>
          ))}
        </div>

        <p className="text-sm font-bold mt-6 mb-2 flex items-center gap-2"><span className="w-6 h-6 rounded-lg bg-accent text-white text-[11px] font-black flex items-center justify-center">2</span> Link zum Beitrag <span className="text-muted-foreground font-medium">(optional)</span></p>
        <input data-testid="giveaway-posturl-input" className="w-full rounded-xl border-2 border-border bg-white px-4 py-3 text-sm focus:outline-none focus:border-accent transition-colors"
          placeholder="https://tiktok.com/@dein-name/video/…" value={postUrl} onChange={(e) => setPostUrl(e.target.value)} />

        <p className="text-sm font-bold mt-6 mb-2 flex items-center gap-2"><span className="w-6 h-6 rounded-lg bg-accent text-white text-[11px] font-black flex items-center justify-center">3</span> Screenshot deines Beitrags</p>
        <button type="button" data-testid="giveaway-upload-btn" onClick={() => fileRef.current?.click()} disabled={uploading}
          className={`w-full flex items-center gap-3 rounded-2xl border-2 border-dashed px-4 py-5 text-sm font-semibold transition-colors ${image ? "border-green-400 bg-green-50 text-green-800" : "border-border hover:border-accent text-muted-foreground"}`}>
          {image ? <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0" /> : <ImagePlus className="w-5 h-5 text-accent shrink-0" />}
          {uploading ? "Wird hochgeladen…" : image ? image.name : "Bild auswählen oder hierher ziehen (JPG, PNG)"}
        </button>
        <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={upload} data-testid="giveaway-file-input" />

        <div className="mt-6 space-y-3 bg-secondary/50 border border-border rounded-2xl p-4">
          <label className="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" data-testid="giveaway-terms-checkbox" checked={terms} onChange={(e) => setTerms(e.target.checked)} className={check} />
            <span className="text-sm text-foreground/85">
              Ich akzeptiere die <button type="button" onClick={() => scrollToLegal("terms")} className="font-bold text-accent underline underline-offset-2">Teilnahmebedingungen</button> des Gewinnspiels.
            </span>
          </label>
          <label className="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" data-testid="giveaway-privacy-checkbox" checked={privacy} onChange={(e) => setPrivacy(e.target.checked)} className={check} />
            <span className="text-sm text-foreground/85">
              Ich habe den <button type="button" onClick={() => scrollToLegal("privacy")} className="font-bold text-accent underline underline-offset-2">Datenschutzhinweis</button> zur Kenntnis genommen und willige in die Verarbeitung meiner Daten zur Durchführung des Gewinnspiels ein.
            </span>
          </label>
        </div>

        <button data-testid="giveaway-submit-btn" onClick={submit} disabled={busy || uploading || !terms || !privacy}
          className="w-full mt-6 bg-accent text-white font-black text-base py-4 rounded-full hover:opacity-90 active:scale-[0.99] transition-transform disabled:opacity-40 shadow-[0_8px_24px_rgba(255,107,53,0.35)]">
          {busy ? "Wird übermittelt…" : "🚀 Jetzt im Lostopf landen"}
        </button>
        <p className="text-[11px] text-muted-foreground text-center mt-3">Kostenlos · kein Kauf nötig · eine Teilnahme pro Person</p>
      </div>
    </div>
  );
}

export default function Gewinnspiel() {
  const { user } = useAuth();
  const [info, setInfo] = useState(null);
  const [me, setMe] = useState(null);

  useEffect(() => {
    api.get("/giveaway").then(({ data }) => setInfo(data)).catch(() => {});
    if (user) api.get("/giveaway/me").then(({ data }) => setMe(data)).catch(() => setMe({ entered: false }));
    else setMe({ entered: false });
  }, [user]);

  const isStaff = user && ["MODERATOR", "ADMIN", "SUPER_ADMIN"].includes(user.role);
  const notStarted = info && new Date(info.start) > new Date();
  const ended = info && new Date(info.end) < new Date();

  const scrollToLegal = (which) => {
    const el = document.getElementById(which === "privacy" ? "datenschutzhinweis" : "teilnahmebedingungen");
    document.querySelector(`[data-testid="legal-tab-${which}"]`)?.click();
    setTimeout(() => el?.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 pb-16 overflow-x-clip">
      <Seo title="Gewinnspiel – KLEDIO" description="Teile ein KLEDIO-Inserat auf Social Media und gewinne iPhones, Bargeld oder Boosts." />
      <Ticker />

      {/* ===== Crazy Hero ===== */}
      <section className="relative mt-5 bg-[#111111] text-white rounded-[28px] overflow-hidden" data-testid="giveaway-hero">
        <div aria-hidden="true" className="absolute -top-28 -left-28 w-[420px] h-[420px] rounded-full opacity-40" style={{ background: "radial-gradient(circle, #FF6B35 0%, transparent 65%)" }} />
        <div aria-hidden="true" className="absolute -bottom-32 right-1/4 w-[300px] h-[300px] rounded-full opacity-[0.15]" style={{ background: "radial-gradient(circle, #FF6B35 0%, transparent 65%)" }} />
        <div className="relative grid lg:grid-cols-[1.15fr_1fr] gap-6 items-stretch">
          <div className="p-6 md:p-10 lg:py-14">
            <div className="flex flex-wrap gap-2.5">
              <span className="-rotate-3 bg-accent text-white text-[11px] font-black tracking-wider uppercase px-3.5 py-1.5 rounded-lg shadow-lg">Jetzt mitmachen!</span>
              <span className="rotate-2 bg-[#FFD166] text-[#111111] text-[11px] font-black tracking-wider uppercase px-3.5 py-1.5 rounded-lg shadow-lg">100 % kostenlos</span>
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.02] mt-5">
              Teilen.<br />Hochladen.<br /><span className="text-accent">Abräumen.</span>
            </h1>
            <p className="text-white/70 text-sm md:text-base mt-4 max-w-md">Teile eines deiner KLEDIO-Inserate auf Social Media und gewinne mit etwas Glück ein iPhone 18 Pro Max, 500 € in bar oder ein fettes Boost-Paket.</p>
            <p className="inline-flex items-center gap-2 mt-5 text-[11px] font-black tracking-[0.2em] uppercase bg-white/10 border border-white/10 rounded-full px-4 py-2" data-testid="giveaway-period">
              <Gift className="w-3.5 h-3.5 text-accent" /> 01.12.2026 – 31.01.2027
            </p>
            <div className="mt-7">
              <a href="#teilnehmen" data-testid="giveaway-hero-cta"
                className="inline-flex items-center gap-2 bg-accent text-white font-black px-8 py-4 rounded-full hover:opacity-90 active:scale-95 transition-transform shadow-[0_8px_24px_rgba(255,107,53,0.45)]">
                Jetzt teilnehmen <PartyPopper className="w-4 h-4" />
              </a>
            </div>
          </div>
          <div className="relative min-h-[300px] lg:min-h-0">
            <img src="/gewinnspiel-hero.jpg" alt="Gewinne: 3× iPhone 18 Pro Max, 3× 500 € und Boost-Pakete"
              className="absolute inset-0 w-full h-full object-cover object-top lg:[clip-path:polygon(12%_0,100%_0,100%_100%,0_100%)]" data-testid="giveaway-promo-image" />
          </div>
        </div>
      </section>

      {/* ===== Prize Bento ===== */}
      <section className="mt-10" data-testid="giveaway-prizes">
        <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight">Das gibt's zu gewinnen</h2>
        <div className="grid sm:grid-cols-3 gap-4 mt-5">
          {PRIZES.map((p) => (
            <div key={p.title} className={`${p.rotate} group bg-white border-2 border-[#111111] rounded-3xl p-5 shadow-[6px_6px_0_#111111] hover:shadow-[3px_3px_0_#FF6B35] hover:border-accent hover:translate-x-[3px] hover:translate-y-[3px] transition-all`}>
              <span className="w-12 h-12 rounded-2xl bg-accent/10 text-accent flex items-center justify-center group-hover:scale-110 transition-transform"><p.icon className="w-6 h-6" /></span>
              <p className="font-display text-4xl font-extrabold mt-4">{p.big}</p>
              <p className="font-display font-bold text-lg leading-tight">{p.title}</p>
              <p className="text-sm text-muted-foreground mt-2">{p.sub}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ===== Steps + Form ===== */}
      <section className="grid lg:grid-cols-[1fr_1.2fr] gap-8 mt-12 items-start">
        <div>
          <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight">So einfach geht's</h2>
          <div className="mt-5 space-y-0">
            {STEPS.map((s, i) => (
              <div key={s.title} className="relative flex gap-4 pb-7 last:pb-0">
                {i < STEPS.length - 1 && <span aria-hidden="true" className="absolute left-[23px] top-12 bottom-0 w-[2px] bg-border" />}
                <span className="relative w-12 h-12 rounded-2xl bg-[#111111] text-accent flex items-center justify-center shrink-0 rotate-3"><s.icon className="w-5 h-5" /></span>
                <div className="pt-1">
                  <p className="font-display font-bold">{i + 1}. {s.title}</p>
                  <p className="text-sm text-muted-foreground mt-1">{s.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          {me === null || info === null ? (
            <div className="h-72 bg-muted rounded-3xl animate-pulse" />
          ) : me.entered && me.entry?.status === "DISQUALIFIED" ? (
            <div className="bg-red-50 border-2 border-red-200 rounded-3xl p-6 md:p-8 text-center" data-testid="giveaway-entered-card">
              <h2 className="font-display text-xl font-extrabold text-red-900">Teilnahme ausgeschlossen</h2>
              <p className="text-sm text-red-800/80 mt-1.5">Deine Teilnahme wurde gemäß den Teilnahmebedingungen ausgeschlossen. Bei Fragen melde dich über die Kontaktseite.</p>
            </div>
          ) : me.entered && me.entry?.status === "WINNER" ? (
            <div className="bg-green-50 border-2 border-green-300 rounded-3xl p-6 md:p-8 text-center" data-testid="giveaway-entered-card">
              <PartyPopper className="w-12 h-12 text-green-600 mx-auto" />
              <h2 className="font-display text-2xl font-extrabold mt-3 text-green-900">🎉 Glückwunsch – gewonnen!</h2>
              <p className="text-sm text-green-800/80 mt-1.5">Du wurdest als Gewinner gezogen. Wir melden uns über dein KLEDIO-Konto mit allen Details zur Übergabe deines Gewinns.</p>
            </div>
          ) : me.entered ? (
            <div className="bg-green-50 border-2 border-green-300 rounded-3xl p-6 md:p-8 text-center" data-testid="giveaway-entered-card">
              <PartyPopper className="w-12 h-12 text-green-600 mx-auto" />
              <h2 className="font-display text-2xl font-extrabold mt-3 text-green-900">Du bist im Lostopf!</h2>
              <p className="text-sm text-green-800/80 mt-1.5">Deine Teilnahme ist registriert. Die Gewinner werden nach dem 31.01.2027 per Losverfahren ermittelt und über ihr KLEDIO-Konto benachrichtigt. Viel Glück! 🍀</p>
            </div>
          ) : !user ? (
            <div className="relative" data-testid="giveaway-login-card">
              <div aria-hidden="true" className="absolute -inset-1 rounded-[28px] bg-gradient-to-br from-accent via-[#FFB38A] to-accent opacity-80 blur-[2px]" />
              <div className="relative bg-white rounded-3xl p-6 md:p-10 text-center">
                <Gift className="w-12 h-12 text-accent mx-auto" />
                <h2 className="font-display text-2xl font-extrabold mt-3">Einloggen &amp; mitmachen!</h2>
                <p className="text-sm text-muted-foreground mt-1.5">Nur einen Klick entfernt vom iPhone 18 Pro Max – die Teilnahme ist kostenlos.</p>
                <Link to="/anmelden" data-testid="giveaway-login-btn" className="inline-block mt-6 bg-accent text-white font-black px-10 py-3.5 rounded-full hover:opacity-90 shadow-[0_8px_24px_rgba(255,107,53,0.35)]">Jetzt anmelden</Link>
              </div>
            </div>
          ) : (
            <>
              {(notStarted || ended) && (
                <div className="bg-[#FFD166]/30 border-2 border-[#FFD166] rounded-2xl px-5 py-4 text-sm font-semibold text-[#5c4a00] mb-4" data-testid="giveaway-inactive-banner">
                  {notStarted ? <>⏳ Das Gewinnspiel startet am <b>01.12.2026</b>. Teilnahmen sind erst ab dann möglich.{isStaff && " Als Admin kannst du das Formular bereits testen."}</> : <>Das Gewinnspiel ist beendet. Die Gewinner werden benachrichtigt.</>}
                </div>
              )}
              {(info.active || isStaff) && <EntryForm onEntered={() => setMe({ entered: true, entry: { status: "SUBMITTED" } })} scrollToLegal={scrollToLegal} />}
            </>
          )}
        </div>
      </section>

      <LegalHub />
    </div>
  );
}
